/**
 * True when the entry is tagged for dayparts that do not overlap the store’s
 * currently active dayparts (Breakfast vs Main Menu, etc.).
 */
export function isEntryOutOfActiveDayParts(
  entry: { dayParts?: readonly string[] | null } | null | undefined,
  activeDayPartIds: readonly string[] | null | undefined
): boolean {
  const entryDayParts = (entry?.dayParts ?? []).filter(Boolean);
  if (!entryDayParts.length || activeDayPartIds == null) {
    return false;
  }
  const active = activeDayPartIds.filter(Boolean);
  return !active.some(id => entryDayParts.includes(id));
}

export type DayPartUnavailableKind = 'item' | 'category' | 'menu';

/** Joins daypart labels for guest-facing “only available on …” copy. */
export function formatDayPartsForMessage(dayParts: readonly string[]): string {
  return dayParts
    .map(part =>
      part
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    )
    .filter(Boolean)
    .filter((part, index, all) => all.indexOf(part) === index)
    .join(', ');
}
